/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const onboardingStageEnum = {
    Draft: 'Draft',
    Submitted: 'Submitted',
    Approved: 'Approved',
    Declined: 'Declined',
    Acknowledged: 'Acknowledged',
    OrganizationCreated: 'OrganizationCreated',
} as const;

export type OnboardingStageEnumKey = (typeof onboardingStageEnum)[keyof typeof onboardingStageEnum];

export type OnboardingStage = OnboardingStageEnumKey;
